module.exports = __webpack_public_path__ + "static/media/YM29_1.edae0e91.jpg";